// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"6981":"48fbafc4e54cdb67","8249":"db0264aeb44c7298","9352":"854b0a7d8882d66e"}[chunkId] + ".css";
};